import { render } from "./SinglePost.vue?vue&type=template&id=7a8448e8"
import script from "./SinglePost.vue?vue&type=script&lang=js"
export * from "./SinglePost.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/kaluxhome-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__